import { render, staticRenderFns } from "./ReasonForLivelihood.vue?vue&type=template&id=0cea1095&lang=true"
import script from "./ReasonForLivelihood.vue?vue&type=script&lang=js"
export * from "./ReasonForLivelihood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports